import { initializeApp } from 'firebase/app';
import { getAuth, initializeAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: 'coolliving.io',
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: `${process.env.VUE_APP_FIREBASE_PROJECT_ID}.appspot.com`,
    // Necesarios para FCM (Web Push). Añade los valores en .env y .env.production:
    //   VUE_APP_FIREBASE_MESSAGING_SENDER_ID=<tu_messaging_sender_id>
    //   VUE_APP_FIREBASE_APP_ID=<tu_app_id>
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

// Inicializar auth con persistencia local para mejorar la experiencia de usuario
const auth = getAuth(app);
// Configurar persistencia para mantener la sesión incluso al refrescar la página
setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    console.error("Error configurando persistencia:", error);
  });

// Inicializar servicios principales directamente para evitar errores de compatibilidad
// mientras mantenemos algunas optimizaciones
const db = getFirestore(app);
const storage = getStorage(app);

// Solo mantener la carga bajo demanda para functions
let _functions = null;

// Función para obtener Functions bajo demanda
const getFunctionService = async () => {
  if (!_functions) {
    // Import dinámico para cargar Functions solo cuando sea necesario
    const { getFunctions } = await import(/* webpackChunkName: "firebase-functions" */ 'firebase/functions');
    _functions = getFunctions(app);
  }
  return _functions;
};

// Función para llamar a Functions de manera optimizada
const callFunction = async (functionName, data) => {
  const functions = await getFunctionService();
  const { httpsCallable } = await import(/* webpackChunkName: "firebase-functions" */ 'firebase/functions');
  const callableFunction = httpsCallable(functions, functionName);
  return callableFunction(data);
};

export { auth, db, storage, callFunction };

